import React from 'react'
import GeorgyPic from '../Assets/Georgi_Tosev.jpg'
import ImageGallery from 'react-image-gallery'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import Article from "./Article";
import {Link} from "react-router-dom";

const linodeObjectUrl  = 'https://cdn.mannheim-urology.com/certificates'
const thumbnailsObjectUrl = `${linodeObjectUrl}/thumbnails`

const linodeObjectUrl2  = 'https://cdn.mannheim-urology.com/photos'
const thumbnailsObjectUrl2 = `${linodeObjectUrl2}/thumbnails`

const images = [
    {
        original: `${linodeObjectUrl2}/Tosev_1.jpeg`,
        thumbnail: `${thumbnailsObjectUrl2}/th_Tosev_1.jpeg`,
    },
    {
        original: `${linodeObjectUrl2}/Tosev_2.jpeg`,
        thumbnail: `${thumbnailsObjectUrl2}/th_Tosev_2.jpeg`,
    },
    {
        original: `${linodeObjectUrl2}/Tosev_3.jpeg`,
        thumbnail: `${thumbnailsObjectUrl2}/th_Tosev_3.jpeg`,
    },
    {
        original: `${linodeObjectUrl2}/Tosev_4.jpeg`,
        thumbnail: `${thumbnailsObjectUrl2}/th_Tosev_4.jpeg`,
    },
    {
        original: `${linodeObjectUrl}/desk.jpg`,
        thumbnail: `${thumbnailsObjectUrl}/desk.jpg`,
    },
    {
        original: `${linodeObjectUrl}/room_number_two.jpg`,
        thumbnail: `${thumbnailsObjectUrl}/room_number_two.jpg`,
    },
    {
        original: `${linodeObjectUrl}/lamp.jpg`,
        thumbnail: `${thumbnailsObjectUrl}/lamp.jpg`,
    }
]

const About = () => {
    const { t } = useTranslation()
    const language = useSelector(state => state.language)

    switch (language) {
        case 'RU':
            return (
                <section id="about">
                    <div className="row">
                        <div className="three columns">

                        <figure>
                          <img src={GeorgyPic} alt="Georgy Tosev photo"lign="left" width="300"/>
                          <figcaption>Д-р Георги Тосев </figcaption>
                        </figure>
                        </div>
                        <div className="nine columns main-col">
                            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                                <h3>Д-р Георгий Тосев</h3>
                                    Специалист по урологии, андрологии, уроонкологии и урологической образной диагностике.
                                <h4>Медицинское образование и специализация</h4>
                                Окончил медицинский факультет Венского медицинского университета, Австрия. Закончил специализацию по урологии в урологической клинике города Гейдельберга, Германия и получил квалификацию по следующим специальностям: андрология, уроонкология и урологическая диагностика.<br/>
                                Специалист по малоинвазивной терапии доброкачественной гиперплазии простаты с помощью методики Rezum™ - Boston Scientific. Доктор Тосев первым на территории Германии провел операцию с использованием методики Rezum™ в частном центре общей урологической врачебной практики.<br/>
                                Специалист по эректильной дисфункции, преждевременной эякуляции и болезни Пейрони (фибропластическая индурация полового члена)<br/>
                                Лечение рака мочевого пузыря методикой HIVEC™.<br/>
                                Лечение стриктуры уретры методикой Optilume™.<br/>
                                Автор и соавтор статей в области урологии, опубликованных во многих всемирно признанных медицинских журналах.
                            </div>
                            <ImageGallery items={images} />
                        </div>
                    </div>
                </section>
            )
        case 'BG':
            return (
                <section id="about">
                    <div className="row">
                        <div className="three columns">

                        <figure>
                          <img src={GeorgyPic} alt="Georgy Tosev photo"lign="left" width="300"/>
                          <figcaption>Д-р Георги Тосев </figcaption>
                        </figure>
                        </div>
                        <div className="nine columns main-col">
                            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                                <h3>Д-р Георги Тосев</h3>
                                    Специалист по урология, андрология, уро-онкология и урологична образна диагностика.
                                <h4>Медицинско образование и специализация</h4>
                                Завършил медицина в Медицински университет Виена, Австрия. Специализирал в Университетската урологична клиника в Хайделберг, Германия и придобил квалификации в подспециалностите: андрология, уро-онкология и урологична образна диагностика.<br/>
                                Експерт в минимално инвазивната терапия на доброкачествена простатна хиперплазия с най-новите иновативни технологии, включително Резум™ на Boston Scientific. Д-р Тосев е първият, който извършва операция с Резум™ технологията в частна урологична практика на територията на Федерална Република Германия.<br/>
                                Специалист по лечение на еректилна дисфункция, преждевременна еякулация и болест на Пейрони (индурацио пенис пластика).<br/>
                                Лечение на рак на пикочния мехур с метода HIVEC™.<br/>
                                Лечение на уретралната стриктура с метода Optilume™.<br/>
                                Автор и съавтор на множество публикации в областта на урологията, публикувани в международно признати медицински журнали. <br/>
 <hr/>
                                <h3>Вижте следната статия:</h3>
                                <Link to="/article-1" style={{"color": "#11ABB0"}}>Обещаваща нова технология дава надежда на милиони мъже в цяла Европа, страдащи от стриктурa на уретрата</Link>
                                <hr/>
 
                            </div>
                            <ImageGallery items={images} />
                        </div>
                    </div>
                </section>
            )
        case 'EN':
            return (
                <section id="about">
                    <div className="row">
                        <div className="three columns">

                        <figure>
                          <img src={GeorgyPic} alt="Georgy Tosev photo"lign="left" width="300"/>
                          <figcaption>Dr. Georgy Tosev</figcaption>
                        </figure>
                        </div>
                        <div className="nine columns main-col">
                            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">


                                    <h4>Mannheim Urology - еxperts in Urology, Andrology, Uro-Oncology, and Urological Imaging </h4>
 
                                <p>
 
At Mannheim Urology, we are committed to providing exceptional urological, andrological, and medicinal tumor therapy services. We employ the latest advancements in these fields to ensure that our patients receive top-quality treatment. 
Our lead physician, Dr. Tosev, graduated from the Medical University of Vienna, Austria, and brings years of experience from the University Hospital in Heidelberg, Germany to offer a wide range of urological services. He is also a renowned researcher, having conducted numerous high-profile medical case studies in urology. You can find more information about his research on our <a href='/Papers' style={{ color: '#11ABB0' }} >research studies in urology page</a>. Choose Mannheim Urology for exceptional urological care and the expertise of our lead physician in both practice and research.

One of our specialties is the treatment of urethral strictures using Optilum balloons. Dr. Tosev and his team were the first to introduce this innovative treatment to Europe in January 2021. Since then, we have successfully treated dozens of patients and have earned recognition as the first Ambassador Center in Europe for training external specialists. Choose Mannheim Urology for exceptional urological care.

We also use Rezum™ therapy, a minimally invasive and potency-sparing treatment for benign prostatic hyperplasia (BPH), which has been in use since 2019. Dr. Tosev is one of the first urologists in Germany to receive the Center of Excellence certificate for this treatment, and we have established it as an outpatient procedure.

Our practice also specializes in treating erectile dysfunction using medical shock wave therapy, therapeutic ultrasound, and intracavernosal injection therapy of Botox. We have also developed a promising non-invasive therapy concept for penile curvature, which includes shock wave therapy of the penis, therapeutic ultrasound, iontophoresis, antioxidant therapy, and mechanical therapy of the penis with penile extender.

Finally, to improve early detection of prostate cancer in men, we were the first urology practice in Germany to establish the Stockholm-3 test. Choose Mannheim Urology for high-quality and effective urological treatments.

    Our urological practice offers comprehensive and competent support from diagnosis to aftercare for both outpatient and inpatient patients. We specialize in early detection of testicular tumors using microRNA-371a, a highly sensitive and specific tumor marker for testicular germ cell tumors that simplifies clinical management.

If you have any questions about our services, please don't hesitate to contact us. We look forward to working with you.</p>


                                <p>
 
 Dr. med. univ. Georgi Tosev,<br/>  FEBU Specialist in Urology, Andrology, and Medical Tumor Therapy, and our team.
</p>
                            </div>
                            <ImageGallery items={images} />
                        </div>
                    </div>
                </section>
            )
        default:
            return (
                <section id="about">
                    <div className="row">
                        <div className="three columns">
                        <figure>
                          <img src={GeorgyPic} alt="Georgy Tosev photo"lign="left" width="300"/>
                          <figcaption>Dr. Georgy Tosev</figcaption>
                        </figure>
                        </div>
                        <div className="nine columns main-col">
                            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                                <h3>Dr. Georgi Tosev</h3>
                                    <h3>Expertise in Urology, Andrology, Uro-Oncology, and Urological Imaging </h3>
                                <h3>Medical education and specialization</h3>
                                <p>Dr. Georgi Tosev is a highly qualified specialist in urology with additional expertise in andrology, uro-oncology, and urological imaging. He completed his medical education at the prestigious Medical University of Vienna, Austria, and his specialization in urology at the University Urology Clinic in Heidelberg, Germany.</p>
<p>With a strong focus on patient-centered care, Dr. Tosev is dedicated to providing the latest and most advanced treatments in urology. He is an expert in minimally invasive therapy of benign prostatic hyperplasia with the latest innovative technology Rezum™ - Boston Scientific. Dr. Tosev was the first to implement and conduct an operation with Rezum™ technology in a private urological practice on the territory of the Federal Republic of Germany.</p>
<p>Dr. Tosev's expertise also extends to the treatment of erectile dysfunction, premature ejaculation, Peyronie's disease, bladder cancer with the HIVEC method™, and urethral stricture with the Optilume method™. He is an author and co-author of numerous publications in the field of urology, published in internationally recognized medical journals.</p>
<p>At our practice, we are committed to providing our patients with the highest quality care, utilizing the latest techniques and technologies available. Schedule your appointment with Dr. Tosev today to receive expert and compassionate care for your urological needs.</p>
                            </div>
                            <ImageGallery items={images} />
                        </div>
                    </div>
                </section>
            )
    }
}

export default About



// WEBPACK FOOTER //
// ./src/Components/About.js